import httpService from '../../../core/services/http.service';

function index() {
  return httpService.get('/tags');
}

export default {
  index
};
